import Aos from 'aos';

export default () => {

    Aos.init();
    
};